// Registro central dos canais de origem das conversas.
//
// O backend envia o canal em `chatSource` (ex.: 'whatsapp' | 'instagram' | 'evolution').
// Para adicionar um canal novo NÃO é preciso mexer na UI: basta o backend mandar um
// novo `chatSource`. Se ele não estiver mapeado aqui, o fallback gera um rótulo legível
// a partir do próprio nome do source, então o canal aparece automaticamente.
export interface ChannelBadge {
  // Emoji/ícone curto exibido antes do nome.
  icon: string;
  // Nome legível do canal (WhatsApp, Instagram, ...).
  label: string;
}

// Canais conhecidos. Chaves devem bater com os valores de `ChatSource` do backend.
const CHANNELS: Record<string, ChannelBadge> = {
  whatsapp: { icon: '📱', label: 'WhatsApp' },
  instagram: { icon: '📸', label: 'Instagram' },
  evolution: { icon: '🟢', label: 'Evolution' },
};

// Canal usado quando o chat não traz `source` (chats antigos, anteriores ao campo).
const DEFAULT_CHANNEL: ChannelBadge = CHANNELS.whatsapp;

export function getChannelBadge(source?: string): ChannelBadge {
  if (!source) return DEFAULT_CHANNEL;
  const known = CHANNELS[source.toLowerCase()];
  if (known) return known;
  // Canal novo ainda não catalogado: mostra ícone genérico + nome capitalizado do source.
  return { icon: '💬', label: capitalize(source) };
}

// "icon label" pronto para concatenar em uma linha de texto.
export function getChannelTag(source?: string): string {
  const { icon, label } = getChannelBadge(source);
  return `${icon} ${label}`;
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
